
  function addUpsellProduct(productId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: 1, id: productId }),
    })
      .then(response => response.json())
      .then(data => {
        console.log("Product added:", data);
        localStorage.setItem("openCartDrawer", "true"); // Store flag before reloading
        location.reload(); // Refresh the page
      })
      .catch(error => console.error("Error adding product:", error));
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Attach event listeners to upsell buttons
    document.querySelectorAll(".btn-add-upsell").forEach(button => {
      button.addEventListener("click", function () {
        let productId = this.getAttribute("data-product-id");
        addUpsellProduct(productId);
      });
    });

    // Open cart drawer after page reload if flagged
    if (localStorage.getItem("openCartDrawer") === "true") {
      localStorage.removeItem("openCartDrawer"); // Remove flag to prevent multiple openings
      setTimeout(() => {
        let cartButton = document.querySelector("a.site-nav__link.site-nav__link--icon.cart-link.js-drawer-open-button-right");
        if (cartButton) {
          cartButton.click(); // Open cart drawer
        } else {
          console.error("Cart drawer button not found");
        }
      }, 500); // Small delay to ensure the page fully loads
    }
  });